import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useContextMenuPosition, { ContextMenuPosition } from 'frontcore/views/context-menu/useContextMenuPosition'
import { ref, toRefs } from 'vue'

type Props = {
  anchor: HTMLElement | null
  positions: ContextMenuPosition[]
  withAnchorWidth?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CoreContextMenu',
  props: {
    anchor: {},
    positions: {},
    withAnchorWidth: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
const { anchor, positions, withAnchorWidth } = toRefs(props)

const contextMenu = ref<HTMLElement | null>(null)
const positionStyle = useContextMenuPosition(anchor, contextMenu, positions, withAnchorWidth)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "contextMenu",
    ref: contextMenu,
    class: "core-context-menu",
    style: _normalizeStyle(_unref(positionStyle))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})